import { PARTNERS } from "@/lib/products";

export default function Partners() {
  return (
    <section data-testid="partners-section" className="py-12 md:py-16 bg-white border-y border-slate-100">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="text-center max-w-2xl mx-auto">
          <span className="eyebrow">Insurance Partners</span>
          <h3 className="font-display mt-3 text-xl md:text-2xl font-bold text-slate-900">
            Powered by India&apos;s most-trusted insurers
          </h3>
        </div>
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
          {PARTNERS.map((p, i) => (
            <div
              key={p}
              data-testid={`partner-${i}`}
              className="h-16 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center text-center px-3"
            >
              <span className="font-display text-xs md:text-sm font-bold text-slate-700">
                {p}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
